/**
 * Croatian overrides for one person's page and the Dnevnik's additions.
 *
 * The same moves as the rest of the admin screens: *račun* for *nalog* — the
 * timeline's "Nalog" chip included — *sustav*, *popis*, *tko* and *što*,
 * *ponovno*, *spremiti*, *vlastiti*. Everything else is inherited; a line that
 * merely repeats its Bosnian base fails the parity test.
 */

import type { PeopleSlice } from '../bs/people'

export const people: Partial<PeopleSlice> = {
  'people.missing.description': 'Možda je obrisana u međuvremenu. Potražite je na popisu korisnika.',
  'people.lastSignIn': 'Posljednja prijava u sustav',
  'people.mes.unfollowed.explain':
    'KaproMES je {when} prestao slati ovu osobu. Račun je ostao kakav je bio — deaktivirajte ga ovdje ako je osoba otišla.',

  'people.action.deactivate.self': 'Ne možete deaktivirati vlastiti račun.',
  'people.action.badge.inactive': 'Kartica se izdaje samo aktivnom računu.',
  'people.activate.confirm': 'Aktivirati račun korisnika „{name}"?',
  'people.activate.body': 'Ponovno se može prijaviti istom lozinkom ili karticom kao prije.',
  'people.deactivate.confirm': 'Deaktivirati račun korisnika „{name}"?',
  'people.deactivate.body':
    'Odmah se odjavljuje sa svih uređaja i ne može se prijaviti dok račun ponovno ne aktivirate. Prijave, zadaci i obilasci ostaju.',
  'people.activated': 'Račun je aktiviran.',
  'people.deactivated': 'Račun je deaktiviran.',
  'people.save.failed': 'Promjena nije spremljena. Pokušajte ponovno.',

  'people.tile.signIns': 'Prijave u sustav, 30 dana',

  'people.activity.explain':
    '„Račun" su izmjene računa ove osobe, tko god da ih je napravio. „Radnje" je ono što je ova osoba sama radila — u administraciji, na prijavama i obrascima. Prijave, zadaci i obilasci samo su iz pogona koje vidite.',
  'people.activity.filter.prijava-u-sistem': 'Prijave u sustav',
  'people.activity.filter.nalog': 'Račun',
  'people.activity.empty.description':
    'Ovdje se pojavljuju prijave u sustav, prijave, zadaci, 5S obilasci i izmjene računa.',
  'people.activity.empty.filter': 'Ove vrste još nema ničega.',

  'admin.log.chip.subjectType': 'Što: {value}',
}
